import { formatPrice } from '../../../../util/PriceUtil';
import { getFormattedDate } from '../../../../util/DateUtil';
export const getPriceSuffix = (isSecureNet, translate) => {
    return `${translate('internetCalculator.price.permonth')}${isSecureNet ? ` ${translate('internetCalculator.price.vat')}` : ''}`;
};
export const getCampaignByCodeFromWpConf = (campaignCode, campaignsFromWpConf) => {
    return campaignCode ? campaignsFromWpConf === null || campaignsFromWpConf === void 0 ? void 0 : campaignsFromWpConf.find((campaign) => campaign.code === campaignCode) : null;
};
export const getDiscountPrice = (discount, campaign, isSecureNet, translate, offer) => {
    const discountPrice = Number(isSecureNet ? discount.discountPriceWithoutTax : discount.discountPrice);
    const regularPrice = isSecureNet ? offer.priceWithoutVat : offer.price;
    const totalPrice = Number(regularPrice) + discountPrice;
    if (!discountPrice) {
        return regularPrice;
    }
    if (totalPrice === 0) {
        return (campaign === null || campaign === void 0 ? void 0 : campaign.duration) ? `${translate(campaign.duration)} ${translate('internetCalculator.price.free')}` : translate('internetCalculator.price.free');
    }
    const formattedPrice = `${formatPrice(totalPrice)} ${getPriceSuffix(isSecureNet, translate)}`;
    return (campaign === null || campaign === void 0 ? void 0 : campaign.duration) ? `${translate(campaign.duration)} ${formattedPrice}` : formattedPrice;
};
export const getDiscountPreText = (d, index, campaign, translate) => {
    if (index === 1) {
        return !!(d === null || d === void 0 ? void 0 : d.discountEndDate)
            ? translate('internetCalculator.following.discount.until', {
                date: getFormattedDate(d === null || d === void 0 ? void 0 : d.discountEndDate)
            })
            : translate('internetCalculator.following.discount');
    }
    return (campaign === null || campaign === void 0 ? void 0 : campaign.type)
        ? translate(`internetCalculator.${campaign.type}`)
        : !(campaign === null || campaign === void 0 ? void 0 : campaign.duration) && d.discountEndDate
            ? translate('internetCalculator.until', {
                date: getFormattedDate(d === null || d === void 0 ? void 0 : d.discountEndDate)
            })
            : null;
};
